import util from '@/tools/commonUtil'
const validQuLogics = function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const { logicType, sortQuItemId, chooseType } = logic
  if ([1, 'question'].includes(logicType) || [2, 'clientProperty'].includes(logicType)) {
    isShow = commonValidLogic(chooseType, quItem, sortQuItemId, anQuItemId)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(logicType, quItem, sortQuItemId, anQuItemId)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId) {
  let resultStr = true
  const { chooseType } = logic
  resultStr = !commonValidLogic(chooseType, value, anQuItemId)
  return resultStr
}

const commonValidLogic = (chooseType, value, anQuItemId) => {
  let isShow = true
  if (chooseType === '1') {
    if (util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  } else if (chooseType === '2') {
    if (!util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/MultiFillBlankBox/logic.js